import { BudgetStatus } from '../types/budget-status.type';

export const BudgetStatusLabel = {
  [BudgetStatus.Draft]: 'Draft',
  [BudgetStatus.Live]: 'Live',
  [BudgetStatus.Test]: 'Test',
  [BudgetStatus.Hidden]: 'Private',
  [BudgetStatus.Reference]: 'Read-Only'
};
